import { Component, Input, OnInit } from '@angular/core';
import { DataUtilService } from '../../_services/data-util.service';
import { StudentService } from '../../_services/student.service';

@Component({
  selector: 'app-progress-report-tab',
  templateUrl: './progress-report-tab.component.html',
  styleUrls: ['./progress-report-tab.component.css']
})
export class ProgressReportTabComponent implements OnInit {
  topics:[]
  loadingReport=false
  renderMathNow=false
  learner:any=undefined
  server_student_user_id=0
  constructor(
    private studentService:StudentService,
    private dataUtilService:DataUtilService
    ) { }

  ngOnInit(): void {
    this.loadingReport=true
    this.studentService.minStudentData.subscribe(
      myinfo=>{
        this.learner=myinfo
        this.server_student_user_id= this.learner.server_user_id
        this.loadProgressReport()
      }
    )

  }
  loadProgressReport(){
    this.studentService.getProgressReport(this.server_student_user_id).subscribe(
      value=>{
        if(this.dataUtilService.isGoodResponse(value)){
          this.topics= this.dataUtilService.myData(value)
          this.loadingReport=false
        }

      }
    )
  }
  renderMathPage(value:boolean){
    Promise.resolve(null).then(() => {
      this.renderMathNow=value
    })

  }
}
